export default {
  pl: {
    day1: {
      full: 'poniedziałek',
      short: 'pon',
      shortPart1: 'pon',
      shortPart2: 'iedziałek'
    },
    day2: {
      full: 'wtorek',
      short: 'wto',
      shortPart1: 'wto',
      shortPart2: 'rek'
    },
    day3: {
      full: 'środa',
      short: 'śro',
      shortPart1: 'śro',
      shortPart2: 'da'
    },
    day4: {
      full: 'czwartek',
      short: 'czw',
      shortPart1: 'czw',
      shortPart2: 'artek'
    },
    day5: {
      full: 'piątek',
      short: 'pią',
      shortPart1: 'pią',
      shortPart2: 'tek'
    },
    day6: {
      full: 'sobota',
      short: 'sob',
      shortPart1: 'sob',
      shortPart2: 'ota'
    },
    day7: {
      full: 'niedziela',
      short: 'nie',
      shortPart1: 'nie',
      shortPart2: 'dziela'
    }
  },
  en: {
    day1: {
      full: 'monday',
      short: 'mon',
      shortPart1: 'mon',
      shortPart2: 'day'
    },
    day2: {
      full: 'tuesday',
      short: 'tue',
      shortPart1: 'tue',
      shortPart2: 'sday'
    },
    day3: {
      full: 'wednesday',
      short: 'wed',
      shortPart1: 'wed',
      shortPart2: 'nesday'
    },
    day4: {
      full: 'thursday',
      short: 'thu',
      shortPart1: 'thu',
      shortPart2: 'rsday'
    },
    day5: {
      full: 'friday',
      short: 'fri',
      shortPart1: 'fri',
      shortPart2: 'day'
    },
    day6: {
      full: 'saturday',
      short: 'sat',
      shortPart1: 'sat',
      shortPart2: 'urday'
    },
    day7: {
      full: 'sunday',
      short: 'sun',
      shortPart1: 'sun',
      shortPart2: 'day'
    }
  }
};
